module.exports = __webpack_public_path__ + "img/new_47.373d41bb.jpg";